import { apiPut } from "../baseApi";

export const updateUser = async (data, id) => {
  try {
    const response = await apiPut("_domainUser", id, data);
    return { ...response};
  } catch (error) {
    return Promise.reject(error);
  }
};
